import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rotating-top-player" }
const _hoisted_2 = { class: "top-player-title" }
const _hoisted_3 = { class: "featured-role" }
const _hoisted_4 = { class: "role-details" }
const _hoisted_5 = { class: "role-label" }
const _hoisted_6 = { class: "role-name" }
const _hoisted_7 = { class: "player-summary" }
const _hoisted_8 = { class: "d-flex align-center pa-3" }
const _hoisted_9 = { class: "no-data-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TeammateProfile = _resolveComponent("TeammateProfile")!
  const _component_PlayerIcon = _resolveComponent("PlayerIcon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('stats.topPlayerTitle')), 1),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.currentRole && _ctx.topPlayer && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: _ctx.currentRole,
              class: "top-player-card",
              to: { name: 'user_stats', params: { uuid: _ctx.topPlayer.userID } }
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TeammateProfile, {
                  teammateID: _ctx.topPlayer.userID,
                  class: "featured-player"
                }, null, 8, ["teammateID"]),
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_component_PlayerIcon, {
                    icon: _ctx.currentRole,
                    class: "role-card-image",
                    "aria-hidden": "true"
                  }, null, 8, ["icon"]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('stats.role')), 1),
                    _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.$t(`roles.${_ctx.currentRole}`)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('stats.winPercentage', { percent: Math.round(_ctx.topPlayer.winrate) })), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("span", { "aria-hidden": "true" }, "·", -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('stats.gamesPlayed', { count: _ctx.topPlayer.gamesCount })), 1)
                ])
              ]),
              _: 1
            }, 8, ["to"]))
          : (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 1,
                type: "image",
                class: "top-player-skeleton"
              }))
            : (_openBlock(), _createBlock(_component_v_card, {
                key: 2,
                class: "top-player-card no-data-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "no-data-icon mr-2" }, "🏆", -1)),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('stats.noTopPlayerData')), 1)
                  ])
                ]),
                _: 1
              }))
      ]),
      _: 1
    })
  ]))
}